exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification[data-v-7341193d]{display:flex;flex-wrap:wrap;align-items:center;background-color:#fff;border-style:solid;border-width:2px}.notification.notification-read[data-v-7341193d]{border-color:var(--border-color)}.notification.notification-read svg[data-v-7341193d]{color:var(--secondary)}.notification.notification-unread[data-v-7341193d]{border-color:var(--primary)}.notification.notification-unread svg[data-v-7341193d]{color:var(--primary)}.notification .notification-text[data-v-7341193d]{flex:1 1 0;min-width:130px}.notification .notification-date[data-v-7341193d]{flex:0 1 auto}", ""]);

// exports
